module.exports = __webpack_public_path__ + "static/img/ip@2x.ffcdf4f1.png";